var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    {
      staticClass: "scroll",
      attrs: { "justify-space-between": "", "align-content-start": "" },
    },
    [
      _c(
        "v-container",
        { staticClass: "column-container download-col" },
        [
          _c(
            "v-layout",
            { attrs: { column: "", "align-center": "" } },
            [
              _c("div", { staticClass: "substep-number mb-3" }, [_vm._v("1")]),
              _vm._v(" "),
              _c("div", { staticClass: "subheader mb-3" }, [
                _c("strong", [_vm._v("Download")]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mb-3" }, [
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "To get started we first recommend downloading the " +
                        _vm._s(
                          _vm.currentStep.charAt(0).toUpperCase() +
                            _vm.currentStep.slice(1)
                        ) +
                        " template that shows you how to correctly structure your data"
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary" },
                  on: { click: _vm.downloadTemplate },
                },
                [_vm._v("Download Template")]
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("img", {
                attrs: {
                  src: "dist/images/" + _vm.currentStep + "-template.png",
                  width: "100%",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "example-text mt-2" }, [
                _vm._v(
                  "Example " +
                    _vm._s(
                      _vm.currentStep.charAt(0).toUpperCase() +
                        _vm.currentStep.slice(1)
                    ) +
                    " template"
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-container",
        { staticClass: "column-container edit-col" },
        [
          _c(
            "v-layout",
            { attrs: { column: "", "align-center": "" } },
            [
              _c("div", { staticClass: "substep-number mb-3" }, [_vm._v("2")]),
              _vm._v(" "),
              _c("div", { staticClass: "subheader mb-3" }, [
                _c("strong", [_vm._v("Edit")]),
              ]),
              _vm._v(" "),
              _vm.currentStep === "buildings"
                ? _c("buildings-guidelines")
                : _vm._e(),
              _vm._v(" "),
              _vm.currentStep === "networks"
                ? _c("networks-guidelines")
                : _vm._e(),
              _vm._v(" "),
              _vm.currentStep === "spaces" ? _c("spaces-guidelines") : _vm._e(),
              _vm._v(" "),
              _vm.currentStep === "sensors"
                ? _c("sensors-guidelines")
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-container",
        { staticClass: "column-container upload-col" },
        [
          _c(
            "v-layout",
            { attrs: { column: "", "align-center": "" } },
            [
              _c("div", { staticClass: "substep-number mb-3" }, [_vm._v("3")]),
              _vm._v(" "),
              _c("div", { staticClass: "subheader mb-3" }, [
                _c("strong", [_vm._v("Upload")]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mb-3" }, [
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      'Save the file after editing with "' +
                        _vm._s(
                          _vm.currentStep.charAt(0).toUpperCase() +
                            _vm.currentStep.slice(1)
                        ) +
                        '" as the file name and make sure the file format is in CSV form with UTF-8 encoding.'
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "Note that this upload acts as an “append” and not a replacement. If you were to have 100 " +
                        _vm._s(_vm.currentStep) +
                        " already then upload only 1 row with a new unique id field, you’d have 101 spaces after a successful upload."
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { color: "primary" }, on: { click: _vm.upload } },
                [_vm._v("Ready to upload")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }